import { Col, Container, InputGroup, Row } from 'react-bootstrap';
import AutoSuggestionSelectComponent from 'src/Member/components/common/auto-suggestion-select/Select';
import TextInput from 'src/Components/GenericInputText/TextInput';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';

const FilterPanel = ({
  SORT_BY_DROPDOWN_OPTIONS = [],
  sortByData,
  setSortByData,
  searchText,
  onSearch,
  setCurrentPage,
}) => {
  return (
    <div>
      <div className="messaging-filter-container filter-bar-border-top filter-bar-border-bottom mt-2 mb-md-4 mb-xs-3">
        <Container>
          <Row className="">
            <Col lg={2} md={2} className="Sort_by_option px-0 py-3 ml-3">
              <div className="filter-data1 d-flex gap-3 align-items-center">
                <div>
                  <span className="dropdown_label">Sort By:</span>
                </div>
                <div>
                  <AutoSuggestionSelectComponent
                    options={SORT_BY_DROPDOWN_OPTIONS}
                    components={{ IndicatorSeparator: () => null }}
                    value={sortByData}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSortByData(e);
                    }}
                    isSearchable={false}
                    inputClassName="height-32"
                    aria-labelledby="forsortby"
                  />
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md={4}
              lg={4}
              className="ml-1 border-right-documents py-3"
            >
              <label htmlFor="filterByTitleReference" className="sr-only">
                By Subject, Description or From
              </label>
              <TextInput
                parentClassName="document-search"
                append={
                  <InputGroup.Text>
                    <SearchSVG.SearchSVG className="primary-text-color" />
                  </InputGroup.Text>
                }
                inputProps={{
                  type: 'text',
                  placeholder: 'By Subject, Description or From',
                  className: 'border-right-0 height-32',
                  value: searchText,
                  onChange: onSearch,
                  id: 'filterByTitleReferenceUpdateReminder',
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default FilterPanel;
